/* ==========================================================================
   ORIGGO — Landing page
   Configuração: no editor do tema (seção "LP Grupo VIP").
   ========================================================================== */

// Os valores reais vêm da seção "LP Grupo VIP" (window.LP_VIP_CONFIG, definido
// em sections/lp-vip.liquid). Os de baixo são só o padrão se faltar algo.
const CONFIG = Object.assign({
  whatsappUrl: '#',
  videosHero: [],
  sobreposicaoVideos: 1,
}, window.LP_VIP_CONFIG || {});

/* --------------------------------------------------------------------------
   Altura: a LP ocupa o resto da tela abaixo do cabeçalho do tema. Mede quanto
   espaço há acima dela e entrega ao CSS em --lp-vip-topo.
   -------------------------------------------------------------------------- */
(function alturaAbaixoDoCabecalho() {
  const lp = document.querySelector('.lp-vip');
  if (!lp) return;
  const medir = () => {
    const topo = lp.getBoundingClientRect().top + window.scrollY;
    lp.style.setProperty('--lp-vip-topo', `${Math.max(0, Math.round(topo))}px`);
  };
  // O cabeçalho do tema muda de altura enquanto carrega (fontes, logo, apps):
  // mede de novo em cada um desses momentos.
  medir();
  window.addEventListener('load', medir);
  window.addEventListener('resize', medir);
  if (document.fonts) document.fonts.ready.then(medir);
  setTimeout(medir, 1500);
})();

/* --------------------------------------------------------------------------
   Botões do WhatsApp
   -------------------------------------------------------------------------- */
(function linksWhatsApp() {
  const botoes = document.querySelectorAll('[data-whatsapp]');
  if (!botoes.length) return;

  const url = (CONFIG.whatsappUrl || '').trim();
  const valido = url && url !== '#';

  if (!valido) {
    console.warn('[ORIGGO] CONFIG.whatsappUrl ainda não foi preenchido em script.js.');
  }

  botoes.forEach((el) => {
    if (valido) {
      el.href = url;
      return;
    }
    // Sem link configurado: não leva a lugar nenhum, mas continua focável.
    el.setAttribute('aria-disabled', 'true');
    el.addEventListener('click', (ev) => ev.preventDefault());
  });
})();

/* --------------------------------------------------------------------------
   Vídeos do hero (WebM com transparência), um após o outro
   Cada vídeo fica na sua posição. Faltando CONFIG.sobreposicaoVideos segundos
   para o vídeo da vez acabar, o próximo entra com fade; o que terminou sai.
   -------------------------------------------------------------------------- */
(function videosDoHero() {
  const fig = document.querySelector('[data-hero-video]');
  if (!fig) return;

  const primeiro = fig.querySelector('video');
  const source = primeiro.querySelector('source');
  const still = fig.querySelector('.hero__still');
  const reduzido = window.matchMedia('(prefers-reduced-motion: reduce)');
  const lista = (CONFIG.videosHero || []).filter((item) => item && item.src);
  const sobreposicao = Math.max(0, Number(CONFIG.sobreposicaoVideos) || 0);
  let usandoFoto = false;

  // O primeiro vídeo já está no HTML (com o 1º arquivo da lista).
  primeiro.dataset.posicao = (lista[0] && lista[0].posicao) || 'centro';
  primeiro.style.setProperty('--fade-in', `${sobreposicao}s`);
  primeiro.classList.add('is-on');

  const tocar = (v) => {
    const p = v.play();
    if (p && typeof p.catch === 'function') p.catch(() => {});
  };

  // Safari e iPhone tocam WebM, mas sem a transparência: o fundo viria opaco
  // atrás do letreiro. Nesses casos (ou se o vídeo nem carregar) entra o
  // quadro parado; se ele também não existir, o hero fica só com o letreiro.
  const usarFoto = () => {
    if (usandoFoto) return;
    usandoFoto = true;
    fig.querySelectorAll('video').forEach((v) => v.pause());
    fig.classList.add('is-still');
    if (still && still.dataset.src) {
      still.addEventListener('error', () => { fig.hidden = true; }, { once: true });
      still.src = still.dataset.src;
    } else {
      fig.hidden = true;
    }
  };

  // O canto superior esquerdo do quadro é vazio no recorte: se ele vier
  // opaco, o navegador descartou o canal alfa.
  const temTransparencia = () => {
    try {
      const c = document.createElement('canvas');
      c.width = 8;
      c.height = 8;
      const ctx = c.getContext('2d', { willReadFrequently: true });
      ctx.drawImage(primeiro, 0, 0, 8, 8);
      return ctx.getImageData(0, 0, 1, 1).data[3] < 250;
    } catch {
      return true; // na dúvida, mantém o vídeo
    }
  };

  if (!primeiro.canPlayType('video/webm') || primeiro.networkState === HTMLMediaElement.NETWORK_NO_SOURCE) {
    usarFoto();
    return;
  }
  if (source) source.addEventListener('error', usarFoto, { once: true });

  const conferir = () => { if (!temTransparencia()) usarFoto(); };
  if (primeiro.readyState >= 2) conferir();
  else primeiro.addEventListener('loadeddata', conferir, { once: true });

  if (reduzido.matches) {
    // Quem pediu menos movimento no sistema vê o primeiro quadro, parado.
    primeiro.removeAttribute('autoplay');
    primeiro.pause();
    return;
  }

  // Um <video> por item da lista; cada um só carrega quando está perto da vez.
  const videos = [primeiro];
  lista.slice(1).forEach((item) => {
    const v = primeiro.cloneNode(false); // sem o <source>
    v.removeAttribute('autoplay');
    v.classList.remove('is-on');
    v.loop = false;
    v.muted = true;
    v.preload = 'none';
    v.dataset.posicao = item.posicao || 'centro';
    v.dataset.src = item.src;
    fig.insertBefore(v, still);
    videos.push(v);
  });

  let roda = videos.slice();       // sai quem não carregar
  let vez = primeiro;              // o vídeo que comanda a troca
  let proximoJaEntrou = false;

  const proximoDe = (v) => roda[(roda.indexOf(v) + 1) % roda.length];

  const carregar = (v) => {
    if (v && v.dataset.src && !v.getAttribute('src')) {
      v.preload = 'auto';
      v.src = v.dataset.src;
    }
  };

  // Só sobrou um vídeo que abre: ele fica em loop, sem troca.
  const ficarSozinho = () => {
    vez.loop = true;
    vez.classList.add('is-on');
    if (vez.ended || vez.paused) {
      vez.currentTime = 0;
      tocar(vez);
    }
  };

  const entrar = (v) => {
    v.currentTime = 0;
    v.classList.add('is-on');
    tocar(v);
    carregar(proximoDe(v)); // já vai buscando o seguinte
  };

  if (roda.length < 2) {
    primeiro.loop = true;
  } else {
    primeiro.loop = false;

    videos.forEach((v) => {
      v.style.setProperty('--fade-in', `${sobreposicao}s`);

      // Arquivo que não existe (ou não abre) sai da roda.
      v.addEventListener('error', () => {
        if (usandoFoto || v === primeiro || !roda.includes(v)) return;
        roda = roda.filter((x) => x !== v);
        v.classList.remove('is-on');
        if (roda.length < 2) { ficarSozinho(); return; }
        carregar(proximoDe(vez));
      });

      v.addEventListener('ended', () => {
        if (usandoFoto) return;
        v.classList.remove('is-on');   // sai com o fade curto
        if (v !== vez || roda.length < 2) return;
        // Normalmente o próximo já entrou 1s antes. Se não entrou (sobreposição
        // 0, ou o que entrou falhou e saiu da roda), entra agora.
        const prox = proximoDe(v);
        if (!prox.classList.contains('is-on')) entrar(prox);
        vez = prox;
        proximoJaEntrou = false;
      });
    });

    // Vigia o tempo do vídeo da vez para disparar o próximo no ponto certo
    // (o evento timeupdate é impreciso demais para 1 segundo).
    const vigiar = () => {
      if (!usandoFoto && roda.length > 1 && !vez.paused && !proximoJaEntrou) {
        const resta = vez.duration - vez.currentTime;
        if (Number.isFinite(resta) && resta <= sobreposicao) {
          proximoJaEntrou = true;
          entrar(proximoDe(vez));
        }
      }
      requestAnimationFrame(vigiar);
    };
    requestAnimationFrame(vigiar);

    carregar(proximoDe(primeiro));
  }

  tocar(primeiro); // alguns navegadores bloqueiam o autoplay mesmo mudo

  // Economiza bateria e banda enquanto o hero está fora da tela.
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(
      ([entry]) => {
        if (usandoFoto) return;
        fig.querySelectorAll('video.is-on').forEach((v) => {
          if (!entry.isIntersecting) v.pause();
          else if (!v.ended) tocar(v);
        });
      },
      { threshold: 0.1 }
    );
    io.observe(fig);
  }
})();

/* --------------------------------------------------------------------------
   Animações de entrada
   -------------------------------------------------------------------------- */
(function revealOnScroll() {
  const items = document.querySelectorAll('.reveal');
  if (!items.length) return;

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced || !('IntersectionObserver' in window)) {
    items.forEach((el) => el.classList.add('is-visible'));
    return;
  }

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        io.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -10% 0px', threshold: 0.12 }
  );

  items.forEach((el) => io.observe(el));
})();
